module.exports = __webpack_public_path__ + "static/media/veh.electrico.9490b678.png";